// removed by extract-text-webpack-plugin
module.exports = {"editContent":"_1ttQDW9BEhVGxeMtLRb7Fb","editable":"hRPg-5hMPfzoHodHZaBq2","isEditing":"_3q0sbVlzHLP--rSAjmmP01"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Editable/Editable.scss
 ** module id = 729
 ** module chunks = 0
 **/